import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function EcommerceTerms() {
  const content = `
    <h2>제1조 (목적)</h2>
    <p>이 약관은 클로젯(이하 "회사")이 운영하는 전자상거래 플랫폼에서 제공하는 전자상거래 관련 서비스 및 기타 서비스의 이용과 관련하여 회사와 이용자 간의 권리·의무 및 책임사항 등을 규정함을 목적으로 합니다.</p>

    <h2>제2조 (정의)</h2>
    <ol>
      <li>"플랫폼"이란 회사가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장을 말합니다.</li>
      <li>"판매자(셀러)"란 플랫폼을 통하여 상품을 판매하는 사업자를 말합니다.</li>
      <li>"이용자"란 플랫폼에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
      <li>"구매자"란 플랫폼을 통하여 재화 또는 용역을 구매하는 이용자를 말합니다.</li>
    </ol>

    <h2>제3조 (회사의 의무)</h2>
    <ol>
      <li>회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화·용역을 제공하는데 최선을 다하여야 합니다.</li>
      <li>회사는 이용자가 안전하게 서비스를 이용할 수 있도록 이용자의 개인정보 보호를 위한 보안 시스템을 갖추어야 합니다.</li>
      <li>회사는 상품이나 용역에 대하여 「표시·광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다.</li>
    </ol>

    <h2>제4조 (플랫폼 운영 방식)</h2>
    <ol>
      <li>회사는 통신판매중개자로서 판매자와 구매자 간의 거래를 중개하는 플랫폼을 제공합니다.</li>
      <li>회사는 플랫폼을 통하여 체결된 거래에 대하여 판매자가 등록한 상품 정보를 관리하며, 실제 거래의 당사자는 판매자와 구매자입니다.</li>
      <li>회사는 판매자가 등록한 상품 정보에 대하여 적법성 및 정확성을 보장할 수 없으므로, 이용자는 상품 구매 전에 반드시 판매자가 제공하는 상품 정보를 확인하여야 합니다.</li>
    </ol>

    <h2>제5조 (서비스의 제공)</h2>
    <p>회사는 다음과 같은 서비스를 제공합니다.</p>
    <ul>
      <li>가. 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결</li>
      <li>나. 구매계약이 체결된 재화 또는 용역의 배송</li>
      <li>다. 결제 대행 서비스</li>
      <li>라. 상품 검색 및 추천 서비스</li>
      <li>마. 장바구니 및 관심상품 관리</li>
      <li>바. 주문 내역 조회 및 관리</li>
      <li>사. 상품 리뷰 작성 및 조회</li>
    </ul>

    <h2>제6조 (재화 등의 구매신청)</h2>
    <p><strong>1.</strong> 이용자는 플랫폼상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, 회사는 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.</p>
    <ul>
      <li>가. 재화 등의 검색 및 선택</li>
      <li>나. 받는 사람의 성명, 주소, 전화번호 등의 입력</li>
      <li>다. 약관내용, 청약철회권이 제한되는 서비스 등에 대한 확인</li>
      <li>라. 이 약관에 동의하고 위 3호의 사항을 확인하거나 거부하는 표시</li>
      <li>마. 재화 등의 구매신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의</li>
      <li>바. 결제방법의 선택</li>
    </ul>

    <h2>제7조 (계약의 성립)</h2>
    <p><strong>1.</strong> 회사는 제6조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지하여야 합니다.</p>
    <ul>
      <li>가. 신청 내용에 허위, 기재누락, 오기가 있는 경우</li>
      <li>나. 미성년자가 담배, 주류 등 청소년보호법에서 금지하는 재화 및 용역을 구매하는 경우</li>
      <li>다. 기타 구매신청에 승낙하는 것이 회사 기술상 현저히 지장이 있다고 판단하는 경우</li>
    </ul>

    <p><strong>2.</strong> 회사의 승낙이 제8조 제1항의 수신확인통지 형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다.</p>

    <h2>제8조 (수신확인통지·구매신청 변경 및 취소)</h2>
    <ol>
      <li>회사는 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다.</li>
      <li>수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 회사는 배송 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다.</li>
    </ol>

    <h2>제9조 (결제방법)</h2>
    <p>이용자는 회사가 제공하는 다음 각 호의 방법 중 가용한 방법으로 재화 등의 대금을 결제할 수 있습니다.</p>
    <ol>
      <li>계좌이체</li>
      <li>신용카드 결제</li>
      <li>간편 결제(토스페이먼츠)</li>
      <li>기타 회사가 제공하는 결제 수단</li>
    </ol>

    <h2>제10조 (배송)</h2>
    <ol>
      <li>회사는 이용자와 재화 등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화 등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다.</li>
      <li>회사는 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다.</li>
      <li>배송 지연이 발생하는 경우 회사는 이용자에게 그 사유와 재배송일을 통보합니다.</li>
    </ol>

    <h2>제11조 (청약철회 등)</h2>
    <p><strong>1.</strong> 회사와 재화 등의 구매에 관한 계약을 체결한 이용자는 「전자상거래 등에서의 소비자보호에 관한 법률」 제13조 제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화 등의 공급이 늦게 이루어진 경우에는 재화 등을 공급받거나 재화 등의 공급이 시작된 날을 말합니다)부터 7일 이내에는 청약의 철회를 할 수 있습니다.</p>

    <p><strong>2.</strong> 이용자는 다음 각 호의 어느 하나에 해당하는 경우에는 회사의 의사에 반하여 제1항에 따른 청약철회 등을 할 수 없습니다.</p>
    <ul>
      <li>가. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우</li>
      <li>나. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우</li>
      <li>다. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우</li>
      <li>라. 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우</li>
    </ul>

    <h2>제12조 (청약철회 등의 효과)</h2>
    <ol>
      <li>회사는 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다.</li>
      <li>회사가 이용자에게 환급을 지연한 때에는 그 지연기간에 대하여 「전자상거래 등에서의 소비자보호에 관한 법률 시행령」이 정하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.</li>
    </ol>

    <h2>제13조 (환불 정책)</h2>
    <ol>
      <li>상품 하자 또는 오배송의 경우: 배송비 무료</li>
      <li>단순 변심의 경우: 왕복 배송비는 구매자 부담</li>
      <li>환불은 결제 수단에 따라 영업일 기준 3~7일 소요될 수 있습니다.</li>
    </ol>

    <h2>제14조 (분쟁해결)</h2>
    <ol>
      <li>회사는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</li>
      <li>회사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다.</li>
    </ol>

    <h2>제15조 (재판권 및 준거법)</h2>
    <ol>
      <li>회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다.</li>
      <li>회사와 이용자 간에 제기된 전자상거래 소송에는 대한민국법을 적용합니다.</li>
    </ol>

    <p><strong>부칙</strong><br>
    본 약관은 2025년 11월 1일부터 시행됩니다.</p>

    <p><strong>회사 정보</strong><br>
    상호: 클로젯<br>
    대표: 김재원<br>
    사업자등록번호: [사업자등록번호 입력 필요]<br>
    통신판매업신고번호: [통신판매업신고번호 입력 필요]<br>
    이메일: admin@clozet.my</p>
  `;

  return (
    <TermsTemplate
      title="전자상거래 이용약관"
      content={content}
      lastUpdated="2025년 11월 1일"
    />
  );
}
